import { MultimediaBase } from "./multimedia-base";

export class Multimedia extends MultimediaBase {
    mediaUrl: string;
    originalMediaUrl: string;
    isNewlyAdded: boolean;
    isNonProfile: boolean;
    options: number[];
    referenceId: number;
}